import React from "react";
import "./Offers.css";
import bundleoffer from "../Assets/Frontend_Assets/allone.png";
import { Link } from "react-router-dom";

const Offers = () => {
  return (
    <section className="lux-offers">

      {/* GLOWS */}
      <span className="lux-offer-glow lux-offer-glow-left"></span>
      <span className="lux-offer-glow lux-offer-glow-right"></span>

      <div className="lux-offers-container">

        {/* LEFT CONTENT */}
        <div className="lux-offers-left">
          <span className="lux-eyebrow">LIMITED DEALS</span>

          <h1 className="lux-offers-title">
            Exclusive <span>Offers</span><br />For You
          </h1>

          <p className="lux-offers-desc">
            Only on Prime Cosmo best-selling premium products
          </p>

          <div className="lux-btns">
            <Link to="/hairoil">
              <button className="lux-btn-primary">Hair Oils</button>
            </Link>

            <Link to="/beardoil">
              <button className="lux-btn-secondary">Beard Oils</button>
            </Link>

            <Link to="/soap">
              <button className="lux-btn-secondary">Goated Soaps</button>
            </Link>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="lux-offers-right">
          <div className="lux-offer-image">
            <img src={bundleoffer} alt="Prime Cosmo Bundle Offer" />
          </div>
        </div>

      </div>
    </section>
  );
};

export default Offers;
